/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `OPEN` - Open
 * * `CLOSE` - Close
 * * `LOW` - Low
 * * `HIGH` - High
 * * `VWAP` - Volume-weighted average (VWAP) price
 */
export type PricePointEnum = typeof PricePointEnum[keyof typeof PricePointEnum];


export const PricePointEnum = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
  LOW: 'LOW',
  HIGH: 'HIGH',
  VWAP: 'VWAP',
} as const;
